<template>
  <div class='form-wrapper'>
    <el-form ref="form" :model="eData" :rules="rules" :label-width="labelWidth" style="min-height:300px;">

      <el-row>
        <el-col :span="isCol2?12:24">
          <el-form-item :label="x1.label+'：'" :prop="x1.key" v-for="(x1,i1) in formItemsShowLeft" :key="i1">
            <AreaPicker ref="AreaPicker" :areaIdsChecked="areaIdsChecked" :isShowArea="true" v-if="x1.key==='fixed-area'" />
            <FormItem :x1="x1" :row="eData" :typeKey="isView?'v':'e'" v-else />
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="isCol2">
          <el-form-item :label="x1.label+'：'" :prop="x1.key" v-for="(x1,i1) in formItemsShowRight" :key="i1">
            <FormItem :x1="x1" :row="eData" :typeKey="isView?'v':'e'" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item>
        <el-button type="primary" @click="submitClick" v-if="!isView">确 定</el-button>
        <el-button @click="clearClick(),isShowDialog=false">{{isView?'关 闭':'取 消'}}</el-button>
      </el-form-item>

    </el-form>
    <!-- 图片预览 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import mixin_upload from '@/Mixins/mixin_upload'
// 导入安装好的wangeditor
// import E from 'wangeditor'
// 导入封装好的公共组件wangEditor
import EditorBar from '@/components/wangEditor'
import AreaPicker from '@/components/AreaPicker'
import FormItem from '@/components/XY/FormItem'
export default {
  mixins: [mixin_upload],
  components: { EditorBar, AreaPicker, FormItem },
  props: {
    formItems: { type: Array, default: () => [] },
    action: { type: String, default: '' },
    labelWidth: { type: String, default: '200px' },
    rules: { type: Object, default: () => {} },
    isCol2: { type: Boolean, default: true },
  },
  data() {
    return {
      isView: false,
      eData: {},
      areaIdsChecked: [],
    }
  },
  computed: {
    formItemsShow () {
      return this.formItems.filter(e => this.isView ? !e.vHide : !e.eHide)
    },
    formItemsFixedArea () {
      return this.formItemsShow.find(e => e.key === 'fixed-area')
    },
    formItemsUpload () {
      return this.formItemsShow.filter(e => ['xy_upload','xy_video','xy_document'].includes(this.isView ? e.vType : e.eType))
    },
    formItemsShowLeft () {
      const LIST = this.formItemsShow
      if (this.isCol2) {
        const HALF = LIST.length / -2
        if (this.formItemsFixedArea) return LIST.slice(0, HALF - 1)
        return LIST.slice(0, HALF)
      }
      return LIST
    },
    formItemsShowRight () {
      const LIST = this.formItemsShow
      if (this.isCol2) {
        const HALF = LIST.length / -2
        if (this.formItemsFixedArea) return LIST.slice(HALF - 1)
        return LIST.slice(HALF)
      }
      return null
    },
  },
  methods: {
    numberFormat(val) {
      this.eData[val] ? this.eData[val] = this.eData[val].replace(/[^\.\d]/g,'') : ''
    },
    watchChange(val, isWatch, key) {
      isWatch && this.$emit('watchChange', {key, val})
    },
    clearClick() {
      this.eData = {}
      this.formItemsUpload.forEach(e => e.fileList = [])
    },
    open(type, row) {
      this.clearClick()
      this.isView = type === 3
      switch (type) {
        case 1:
        default:
          break;
        case 2:
        case 3:
          const { provinceId, cityId, countyId, townId, villageId } = row
          this.areaIdsChecked = [provinceId, cityId, countyId, townId, villageId]
          this.eData = JSON.parse(JSON.stringify(row))
          this.fillDateHandler(this.formItemsUpload)
          break;
      }
    },
    fillDateHandler(items) {
      items.forEach(x1 => {
        const target = this.eData[x1.key]
        const IS_LIMIT_1 = !x1.limitNum || x1.limitNum === 1
        switch (x1[this.isView ? 'vType' : 'eType']) {
          case 'xy_upload':
          case 'xy_video':
            if (target && target.length > 0) {
              if (IS_LIMIT_1) {
                x1.fileList = [{ name: target, url: this._img_handler(target), id: target }]
              } else {
                x1.fileList = target.map(x2 => ({ name: x2, url: this._img_handler(x2), id: x2 }))
              }
            }
            break;
          case 'xy_document':
            if (target && (target.fileId || target.length > 0)) {
              if (IS_LIMIT_1) {
                x1.fileList = [{ name: target.fileName, url: this._img_handler(target.fileId), id: target.fileId }]
              } else {
                x1.fileList = target.map(x2 => ({ name: x2.fileName, url: this._img_handler(x2.fileId), id: x2.fileId }))
              }
            }
            break;
        }
      })
    },
    submitClick() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.uploadDataHandler(this.formItemsUpload)

          if (this.formItemsFixedArea) {
            const areaNames = this.$refs.AreaPicker[0].findAreaNames()
            console.log(`%caaa-areaNames:`, 'color: #f00;', areaNames)
            this.eData.province = areaNames[0]
            this.eData.city = areaNames[1]
            this.eData.county = areaNames[2]
            this.eData.town = areaNames[3]
            this.eData.village = areaNames[4]
          }

          this.$emit('submit', this.eData)
        } else { return }
      })
    },
    uploadDataHandler(items) {
      items.forEach(x1 => {
        if (!x1.limitNum || x1.limitNum === 1) {
          if (x1.type === 'xy_document') {
            this.eData[x1.key] = {}
          } else {
            this.eData[x1.key] = ''
          }
        } else {
          this.eData[x1.key] = []
        }
        const IS_LIMIT_1 = !x1.limitNum || x1.limitNum === 1
        switch (x1.type) {
            case 'xy_upload':
            case 'xy_video':
              const x2 = x1.fileList[0] || {}
              this.eData[x1.key] = IS_LIMIT_1 ? x2.id : x1.fileList.map(e => e.id)
              break;
            case 'xy_document':
              const y2 = x1.fileList[0] || {}
              this.eData[x1.key] = IS_LIMIT_1
                ? { fileName: y2.name, fileId: y2.id }
                : x1.fileList.map((e) => ({ fileName: e.name, fileId: e.id }))
              break;
          }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
</style>